<div class="not-found-container">
  <h1>404</h1>
  <h2>Page Not Found</h2>

  <p>The page you are trying to access does not exist.</p>
  
  <button (click)="goBack()">Go to Dashboard</button>
</div>
